module.exports = __webpack_public_path__ + "img/zip.7f994698.jpeg";